import React from "react";
import loader from "../../assets/images/loader.svg"

const CircularProgress = ({className}) => <div className={`loader ${className}`} style={{textAlign:'center'}}>
  <img src={loader} alt="loader" width="80"/>
</div>;
export default CircularProgress;
